export const TWO_FA_CANCELLED_EVENT = 'twoFACancelled'
export const TWO_FA_COMPLETED_EVENT = 'twoFACompleted'
